import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import FeatureSwitch, { matchAny } from '@xingternal/feature-switch';

import { pathOr } from '@xingternal/malt-util/objects';
import UserImage from '@xingternal/profile-image';
import SearchBar from '@xingternal/incremental-search';

import { XDL_NAVIGATOR_TYPES } from '../XingView/XingView';
import { TrackedLink } from '../xing-tracking';
import PersonalBar from '../PersonalBar';
import NotificationCenter from '../NotificationCenter';

const LoggedInSubHeader = ({
  notifications,
  helpLink,
  hasActiveSearchBar,
  activeItem,
  styles,
  user,
  featureSwitches,
  ...props
}) => {
  const { profileImage, displayName, firstName } = user;
  const image = pathOr(null, [0, 'url'], profileImage);

  const userImageProps = {
    profileName: displayName,
    userName: firstName,
    showCaption: false,
    src: image,
    size: '32',
    styles,
  };

  const matchSwitches = matchAny(featureSwitches);
  const isHorizontalMobile = matchSwitches(Object.values(XDL_NAVIGATOR_TYPES));

  const trackingConditions = {
    // eslint-disable-next-line @typescript-eslint/camelcase
    sc_o_PropActionOrigin: false,
  };

  return (
    <Fragment>
      {isHorizontalMobile && (
        <div className={styles.headerProfileWrapper}>
          <TrackedLink
            href="/profile"
            trackingKey="profile"
            conditions={trackingConditions}
            className={styles.profile}
          >
            <UserImage {...userImageProps} />
          </TrackedLink>
        </div>
      )}
      <div className={styles.searchIconPlaceholder} />
      <div
        className={cx(styles.searchBarWrapper, {
          [styles.isOpen]: hasActiveSearchBar,
        })}
      >
        <SearchBar
          className={styles.searchBar}
          isOpened={hasActiveSearchBar}
          matchedMedia="desktop"
          activeItem={activeItem}
          {...props}
        />
      </div>
      <FeatureSwitch flags="notification_center_web">
        <NotificationCenter
          className={styles.notificationCenterWrapper}
          count={notifications.notificationCenterWeb}
        />
      </FeatureSwitch>
      <div className={styles.personalBarWrapper}>
        <PersonalBar className={styles.personalBar} helpLink={helpLink} />
      </div>
    </Fragment>
  );
};

LoggedInSubHeader.propTypes = {
  notifications: PropTypes.object,
  helpLink: PropTypes.string,
  hasActiveSearchBar: PropTypes.bool,
  activeItem: PropTypes.string,
  styles: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  featureSwitches: PropTypes.array.isRequired,
};

export default LoggedInSubHeader;
